import { MarketListItem } from '../../../integrated-client/models/';

export type MarketsList = Array<MarketListItem>;

export class ResultsData {

  items: MarketsList
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}